import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDocument3Fill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M18 2C19.1046 2 20 2.89543 20 4V14H13.5C12.6716 14 12 14.6716 12 15.5V22H6C4.89543 22 4 21.1046 4 20V4C4 2.89543 4.89543 2 6 2H18ZM19.9566 16C19.8771 16.3759 19.6901 16.7241 19.4142 17L15 21.4142C14.7241 21.6901 14.3759 21.8771 14 21.9566V16H19.9566ZM10 11H9C8.44772 11 8 11.4477 8 12C8 12.5523 8.44772 13 9 13H10C10.5523 13 11 12.5523 11 12C11 11.4477 10.5523 11 10 11ZM15 7H9C8.44772 7 8 7.44772 8 8C8 8.55229 8.44772 9 9 9H15C15.5523 9 16 8.55229 16 8C16 7.44772 15.5523 7 15 7Z"
	})
});
export default SvgDocument3Fill;
